import { DeleteGroupRequest } from '@/coreInfrastructureModule/axios/generated/groupManage';

/**
 * グループ削除のアダプタ
 */
export class DeleteGroupAdapter {
  /**
   * リクエストをAPI用に変換する
   * @param groupId - グループID
   */
  public static adaptForRequest(groupId: string): DeleteGroupRequest {
    return {
      deleteGroupInfo: {
        groupId: groupId,
      },
    };
  }
}
